export default {
  get: function (userSettings) {
    let model = {
      'DivisionsId': {
        label: '_'
      },
      '*DivisionName': {
        label: userSettings.Labels.DivisionName,
        width: 30,
        editable: false
      }
    }
    return model
  }
}



// WEBPACK FOOTER //
// ./src/components/_modules/Programs/Card-list/Divisions-list/DivisionModel.js